module.exports = __webpack_public_path__ + "static/media/copy.90aff40b.svg";